import React, { useEffect, useRef } from "react";
import { Check } from "lucide-react";
import { ReactComponent as Logo } from "../../assets/icons/svg/triva_logo.svg";
import { ReactComponent as SuccessIcon } from "../../assets/icons/svg/Signature_Plan_Success_icon.svg";
import { ReactComponent as AvailableOn } from "../../assets/icons/svg/Signature_Plan_Success_available on-image.svg";
import Success from "../../assets/icons/gif/Success.gif";
import { AuthStorage } from "./auth/AuthStorage";

interface TrivaSignaturePlanSuccessPageProps {
  onBackToPlans: () => void;
}

const TrivaSignaturePlanSuccessPage: React.FC<TrivaSignaturePlanSuccessPageProps> = ({ 
  onBackToPlans 
}) => {
  // Auto logout after 30 seconds
  const logoutTimerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    console.log("TrivaSignaturePlanSuccessPage mounted - starting 30s logout timer");

    // Start 30-second logout timer
    logoutTimerRef.current = setTimeout(() => {
      console.log("30 seconds elapsed - clearing auth and redirecting");
      
      // Clear authentication
      AuthStorage.clearAuth();
      
      // Clear any stored payment info
      localStorage.removeItem("lastPaymentSuccess");
      
      // Redirect to login or home page
      window.location.href = "/"; // Change to your login route
    }, 30000); // 30 seconds

    // Cleanup timer on unmount
    return () => {
      if (logoutTimerRef.current) {
        console.log("Cleaning up logout timer");
        clearTimeout(logoutTimerRef.current);
      }
    };
  }, []);

  // Prevent back navigation
  useEffect(() => {
    const handlePopState = (e: PopStateEvent) => {
      e.preventDefault();
      console.log("Back navigation blocked");
      window.history.pushState(null, "", window.location.href);
    };

    // Push initial state
    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  return (
    <div className="min-h-screen flex">
      {/* Left Section */}
      <div className="w-1/2 bg-white px-12">
        {/* Triva Logo */}
        <div className="w-full px-12 py-4 mt-4 3xl:mt-10 4xl:mt-16">
          <div className="flex items-center justify-between">
            <div className="w-[120px] h-[36px] 2xl:w-[120px] 3xl:w-[172px] 3xl:h-[48px] 4xl:w-[200px] 4xl:h-[73px] cursor-pointer">
              <Logo className="w-full h-full object-contain" />
            </div>
          </div>
        </div>

        <div className="flex-1 flex flex-col items-center justify-center min-h-[calc(100vh-200px)] ">
          {/* Success Icon */}
           <div className="relative flex items-center justify-center mx-auto -mb-16 w-[300px] h-[300px]">
                {/* Background GIF Animation */}
                <img
                  src={Success}
                  alt="Success Animation"
                  className="absolute inset-0 w-full h-full object-contain z-0"
                />

                
              </div>

          {/* Success Message */}
          <div className="text-center max-w-md 3xl:max-w-lg ">
            <h1 className="text-[20px] 3xl:text-[24px] font-semibold font-inter text-[#202020] mb-5">
              Thank you for submitting your form!
            </h1>
            <p className="text-gray-600 text-[16px] 3xl:text-lg font-medium font-inter leading-relaxed mb-8">
              Our sales nutritionist will reach out to you between{" "}
              <span className="font-semibold text-[#202020] ">4-5pm</span> today to assist you
              further.
            </p>
            
           
          </div>
        </div>
      </div>

      {/* Right Section */}
      <div className="w-1/2 bg-[#F1FBFB] flex items-center justify-center relative overflow-hidden">
        {/* Install App Section */}
        <div className="flex-1 relative min-h-[600px] flex items-center justify-center">
          <div className="absolute inset-0 flex items-center justify-center">
            <SuccessIcon className="w-[540px] h-[600px] 2xl:h-[600px] 3xl:w-[600px] 3xl:h-[700px] 4xl:w-[700px] 4xl:h-[800px]" />
          </div>
        </div>

        {/* App Store Badges */}
        <div className="fixed bottom-6 w-[200px] h-[60px] 2xl:w-[200px] 2xl:h-[60px] 3xl:w-[250px] 3xl:h-[80px] 4xl:w-[350px] 4xl:h-[100px] cursor-pointer">
          <div className="absolute inset-0 flex items-center justify-center">
            <AvailableOn className="w-full h-full" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrivaSignaturePlanSuccessPage;